export const en = {
  "app.tagline": "Meetings that start in one click.",
  "app.poweredBy": "Powered by BS Group",
  "app.madeIn": "Made with {heart} in Belgium",
  "nav.meetings": "Meetings",
  "nav.rooms": "Rooms",
  "nav.signIn": "Sign in",
  "nav.signOut": "Sign out",
  "nav.createAccount": "Create account",
  "nav.settings": "Settings",
  "nav.docs": "Documentation",
  "nav.privacy": "Privacy",
  "privacy.title": "{name} Privacy Policy",
  "privacy.description": "How {name} handles personal data, meeting content and recordings.",
  "nav.language": "Language",
  "nav.theme": "Theme: {theme}. Switch to {next}",
  "theme.system": "system",
  "theme.light": "light",
  "theme.dark": "dark",

  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.save": "Save",
  "common.done": "Done",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.join": "Join",
  "common.loading": "Loading",
  "common.somethingWentWrong": "Something went wrong",
  "common.you": "you",
  "common.copied": "Copied",
  "common.search": "Search",
  "common.noMatches": "Nothing matches that",

  "landing.intro":
    "{name} is video calling for people who just want to talk: share a code, share a screen, draw on a slide, and get on with it.",
  "landing.startMeeting": "Start a meeting",
  "landing.goToMeetings": "Go to your meetings",
  "landing.codePlaceholder": "abcd-efgh-ijkl",
  "landing.meetingCode": "Meeting code",
  "landing.feature.guests.title": "Guests join with a name",
  "landing.feature.guests.body":
    "No account, no install. Anyone with the link types a name and they are in, with full audio and video.",
  "landing.feature.screen.title": "Screen sharing that stays readable",
  "landing.feature.screen.body":
    "A shared screen is sent at full resolution and letterboxed rather than cropped, so the text survives.",
  "landing.feature.board.title": "Slides and a whiteboard",
  "landing.feature.board.body":
    "Upload a PDF or a PowerPoint and it becomes slides everyone can draw on, together, in the call.",
  "landing.feature.scale.title": "Big rooms, long meetings",
  "landing.feature.scale.body":
    "Up to 500 people in one meeting, and a meeting may run for twenty hours. No seats to count, and nothing that cuts you off after forty minutes.",
  "landing.feature.record.title": "Recording that starts itself",
  "landing.feature.record.body":
    "Switch it on for a room and every meeting in it records from the first person to arrive. Nobody has to remember, and the recording plays back in the browser.",
  "landing.feature.control.title": "Hosts stay in control",
  "landing.feature.control.body":
    "A lobby, per-person roles, mute, remove, and an end-for-everyone that actually ends it.",
  "landing.badge": "No account needed to join",
  "landing.joinTitle": "Have a code?",
  "landing.joinHint": "Paste the link you were sent, or type the code.",
  "landing.chip.install": "Nothing to install",
  "landing.chip.browser": "Works in any modern browser",
  "landing.chip.guests": "Guests join by name",
  "landing.chip.scale": "Up to 500 people, up to 20 hours",
  "landing.preview.alt":
    "A meeting in progress: four people in a grid, with the microphone, camera, screen sharing and whiteboard controls along the bottom.",
  "landing.features.title": "Everything a meeting actually needs",
  "landing.features.body":
    "Not a suite. The few things people actually do on a call, each one built properly.",
  "landing.swipe": "Swipe for more",
  "landing.how.title": "Three steps, no setup",
  "landing.how.1.title": "Start a meeting",
  "landing.how.1.body":
    "Sign in and press one button. The room exists the moment you do, with a code you can read out loud.",
  "landing.how.2.title": "Send the code",
  "landing.how.2.body":
    "Three groups of four letters, or the whole link. Whoever you send it to types their name and walks in.",
  "landing.how.3.title": "Talk, show, draw",
  "landing.how.3.body":
    "Turn the camera on, share a screen, put a deck up and annotate it together while you talk.",
  "landing.faq.title": "Questions people ask first",
  "landing.faq.account.q": "Do I need an account?",
  "landing.faq.account.a":
    "Only to start a meeting. Joining one never needs an account: open the link, type a name, and you are in with full audio and video.",
  "landing.faq.limits.q": "How many people, and how long?",
  "landing.faq.limits.a":
    "Up to 500 people in one meeting, and one meeting may run for up to twenty hours. Nothing is cut short at forty minutes, and there is no seat count to keep an eye on.",
  "landing.faq.install.q": "Is there anything to install?",
  "landing.faq.install.a":
    "No. It runs in the browser on a phone, a tablet or a computer. If you would rather have an icon, it installs to the home screen as an app.",
  "landing.faq.share.q": "Can I share a screen and present slides?",
  "landing.faq.share.a":
    "Yes. A shared screen is sent at full resolution rather than cropped, and a PDF or PowerPoint becomes slides that everyone in the meeting can draw on.",
  "landing.faq.record.q": "Can meetings be recorded automatically?",
  "landing.faq.record.a":
    "Yes. A host can press record in any meeting, or set a room to record every meeting in it from the moment it starts. Everybody in the room is told while a recording is running, and it plays back in the browser afterwards.",
  "landing.faq.control.q": "Who can mute or remove somebody?",
  "landing.faq.control.a":
    "The host, and anyone they make a co-host. There is a lobby, per-person permissions, mute, remove, and an end for everyone that really does end it.",
  "landing.cta.title": "Ready when you are",
  "landing.cta.body": "Start a meeting now, or join one with a code somebody sent you.",
  "landing.integrate.title": "Building on top of it?",
  "landing.integrate.body":
    "{name} has a documented REST and WebSocket API, and service credentials for creating rooms and meetings on behalf of your own users. It is how BS Chat and BS Calendar embed it.",
  "landing.integrate.link": "Read the integration guide",

  "docs.title": "The {name} API",
  "docs.version": "Version 1",
  "docs.errors": "Errors",
  "docs.event": "Event",
  "docs.direction": "Direction",
  "docs.payload": "Payload",
  "docs.inbound": "client to server",
  "docs.outbound": "server to client",
  "docs.body": "Body",
  "docs.returns": "Returns",
  "docs.note": "Note",
  "docs.auth.public": "public",
  "docs.auth.user": "user token",
  "docs.auth.service": "service key",

  "auth.welcomeBack": "Welcome back",
  "auth.signInSubtitle": "Sign in to start and schedule meetings.",
  "auth.createTitle": "Create your account",
  "auth.createSubtitle": "You only need an account to host. Joining never does.",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.currentPassword": "Current password",
  "auth.newPassword": "New password",
  "auth.name": "Name",
  "auth.displayName": "Display name",
  "auth.newHere": "New here?",
  "auth.haveAccount": "Already have an account?",
  "auth.passwordHint": "At least {count} characters",
  "auth.changePassword": "Change password",
  "auth.passwordChanged": "Password changed. Your other sessions have been signed out.",
  "auth.passwordSection": "Changing it signs out every other device.",
  "auth.profileSaved": "Profile saved",
  "auth.nameIsShown": "Your name is what everybody in a meeting sees.",

  "dash.goodMorning": "Good morning",
  "dash.goodAfternoon": "Good afternoon",
  "dash.goodEvening": "Good evening",
  "dash.greeting": "{greeting}, {name}",
  "dash.subtitle": "Start a meeting now, or plan one for later.",
  "dash.startNow": "Start a meeting",
  "dash.instantTitle": "Instant meeting",
  "dash.scheduleLater": "Schedule for later",
  "dash.upcoming": "Upcoming",
  "dash.past": "Past",
  "dash.scheduledCount": "{count} scheduled",
  "dash.nothingScheduled": "Nothing scheduled",
  "dash.nothingScheduledBody":
    "Anything you schedule, and anything you are invited to, shows up here.",
  "dash.loadFailed": "Your meetings could not be loaded. Check your connection and try again.",
  "dash.loadingMeetings": "Loading your meetings",

  "rooms.title": "Your rooms",
  "rooms.subtitle": "A room keeps the same code for as long as it exists.",
  "rooms.loading": "Loading your rooms",
  "rooms.new": "New room",
  "rooms.created": "Room created",
  "rooms.none": "No rooms yet",
  "rooms.noneBody": "Create one to get a code you can reuse for a recurring meeting.",
  "rooms.open": "Open",
  "rooms.copyLink": "Copy the room link",
  "rooms.linkCopied": "Room link copied",
  "rooms.deleteThis": 'Delete "{title}"',
  "rooms.deleteTitle": 'Delete "{title}"?',
  "rooms.deleteBody":
    "Its code stops working, and a link already shared for it stops opening anything.",
  "rooms.delete": "Delete room",
  "rooms.inCall": "{count} in the call",
  "rooms.createdWhen": "Created {when}",
  "rooms.capacity": "Up to {count}",
  "rooms.noHistory": "No meetings have been held in this room yet.",
  "rooms.flag.lobby": "Lobby",
  "rooms.flag.signedInOnly": "Sign-in required",
  "rooms.flag.hostFirst": "Host first",
  "rooms.flag.noRecording": "Recording off",
  "rooms.flag.noChat": "Chat off",
  "rooms.stat.meetings": "Meetings",
  "rooms.stat.joins": "People joined",
  "rooms.stat.joinsHint": "{people} with an account; somebody who rejoined is counted again.",
  "rooms.stat.peak": "Most at once",
  "rooms.stat.totalTime": "Total time",
  "rooms.stat.longestHint": "Longest meeting: {duration}",
  "rooms.stat.messages": "Chat messages",
  "rooms.stat.recordings": "Recordings",
  "rooms.stat.lastMeeting": "Last meeting",

  "schedule.title": "Schedule a meeting",
  "schedule.editTitle": "Edit meeting",
  "schedule.titleField": "Title",
  "schedule.titlePlaceholder": "Weekly sync",
  "schedule.starts": "Starts",
  "schedule.ends": "Ends",
  "schedule.repeat": "Repeat",
  "schedule.repeatNone": "Does not repeat",
  "schedule.repeatDaily": "Every day",
  "schedule.repeatWeekly": "Every week",
  "schedule.repeatTwoWeeks": "Every 2 weeks",
  "schedule.repeatThreeWeeks": "Every 3 weeks",
  "schedule.repeatMonthly": "Every month",
  "schedule.repeatTwoMonths": "Every 2 months",
  "schedule.repeatThreeMonths": "Every 3 months",
  "schedule.timezoneHint":
    "The times above are read in this zone. Everybody else sees them in their own.",
  "schedule.description": "Description",
  "schedule.descriptionPlaceholder": "Agenda, links, anything people should read first.",
  "schedule.inviteByEmail": "Invite by email",
  "schedule.inviteHint": "Type or paste addresses. Space, comma or semicolon finishes each one.",
  "schedule.emailsPlaceholder": "sara@example.com, ali@example.com",
  "schedule.submit": "Schedule",
  "schedule.saved": "Meeting updated",
  "schedule.created": "Meeting scheduled",
  "schedule.cancelTitle": 'Cancel "{title}"?',
  "schedule.cancelBody": "Everybody invited is told it is off.",
  "schedule.cancelAction": "Cancel meeting",
  "schedule.cancelKeep": "Keep it",
  "schedule.cancelled": "Meeting cancelled",

  "meeting.liveNow": "Live now",
  "meeting.cancelled": "Cancelled",
  "meeting.repeats": "Repeats",
  "meeting.fromService": "From {service}",
  "meeting.accepted": "{accepted} of {total} accepted",
  "meeting.copyJoinLink": "Copy the joining link",
  "meeting.invitePeople": "Invite people",
  "meeting.cancelThis": "Cancel this meeting",
  "meeting.linkCopied": "Meeting link copied",

  "invite.title": "Invite people",
  "invite.anyoneWithLink": "Anyone with the link",
  "invite.copyLink": "Copy the link",
  "invite.send": "Send invitations",
  "invite.sent": "{count} invited",
  "invite.invitedCount": "Invited ({count})",
  "invite.copyPersonal": "Copy the personal link for {email}",
  "invite.remove": "Remove {email}",
  "invite.personalCopied": "Personal link copied",
  "invite.status.pending": "pending",
  "invite.status.accepted": "accepted",
  "invite.status.declined": "declined",
  "invite.accept": "Accept",
  "invite.decline": "Decline",
  "invite.invitedYou": "{name} invited you",
  "invite.joinNow": "Join the meeting now",
  "invite.answered": "You have {status} this invitation.",
  "invite.notFound": "Invitation not found",
  "invite.notFoundBody":
    "This invitation link is not valid any more. Ask the organizer to send a new one.",
  "invite.opening": "Opening your invitation",
  "invite.seeYouThere": "See you there",
  "invite.organizerTold": "The organizer has been told",

  "prejoin.joinNow": "Join now",
  "prejoin.askToJoin": "Ask to join",
  "prejoin.yourName": "Your name",
  "prejoin.namePlaceholder": "What should people call you?",
  "prejoin.joiningAs": "Joining as {name}",
  "prejoin.hostedBy": "Hosted by {name}",
  "prejoin.alreadyHere": "{count} already here",
  "prejoin.cameraOff": "Your camera is off",
  "prejoin.lobbyNote": "This meeting has a lobby, so a host has to let you in.",
  "prejoin.joinMuted": "Join muted",
  "prejoin.joinUnmuted": "Join with your microphone on",
  "prejoin.joinCameraOff": "Join with your camera off",
  "prejoin.joinCameraOn": "Join with your camera on",

  "call.meeting": "Meeting",
  "call.connecting": "Connecting",
  "call.reconnecting": "Connection lost. Getting you back in.",
  "call.participantAway": "Reconnecting",
  "call.offline": "No internet connection.",
  "call.retryNow": "Try now",
  "call.joiningSlow": "This is taking longer than it should",
  "call.joiningSlowBody":
    "The meeting is not answering yet. It is still trying, and you can give it a push.",
  "call.backInTheRoom": "You are back in the meeting",
  "call.meetingElapsed": "Meeting length",
  "call.joinedElapsed": "Since you joined",
  "call.joining": "Joining the meeting",
  "call.finding": "Finding the meeting",
  "call.tapToHear": "Tap to hear the call",
  "call.recording": "Recording",
  "call.copyLink": "Copy the meeting link",

  "call.zoomIn": "Zoom in",
  "call.zoomOut": "Zoom out",
  "call.zoomReset": "Fit to the frame",
  "call.fullScreen": "Full screen",
  "call.exitFullScreen": "Leave full screen",
  "call.settings": "Meeting settings",
  "call.startRecording": "Start recording",
  "call.stopRecording": "Stop recording",
  "call.fullscreen": "Full screen",
  "call.exitFullscreen": "Leave full screen",
  "call.mediaTrouble": "Media connection trouble",
  "call.noMediaServer": "This server has no media server, so audio and video are off",
  "call.noMediaServerBody":
    "You can still use chat, the whiteboard and everything else in the meeting. Your own camera is shown to you only.",
  "call.mute": "Mute microphone",
  "call.unmute": "Unmute microphone",
  "call.cameraOn": "Turn on camera",
  "call.micNotAllowed": "The host has turned your microphone off",
  "call.camNotAllowed": "The host has turned your camera off",
  "call.cameraOff": "Turn off camera",
  "call.share": "Share your screen",
  "call.youAreSharing": "You are sharing this screen",
  "call.stopShare": "Stop sharing your screen",
  "call.raiseHand": "Raise your hand",
  "call.lowerHand": "Lower your hand",
  "call.leave": "Leave the meeting",
  "call.leaveOrEnd": "Leave, or end the meeting?",
  "call.leaveOrEndBody":
    "{count} other people are still here. Leave and the meeting carries on without you. End it and everybody is put out of it.",
  "call.leaveOrEndBody#one":
    "{count} other person is still here. Leave and the meeting carries on without you. End it and everybody is put out of it.",
  "call.justLeave": "Just leave",
  "call.endForEveryone": "End for everyone",
  "call.people": "People",
  "call.chat": "Chat",
  "call.present": "Whiteboard",
  "call.settingsTitle": "Settings",
  "call.audioVideo": "Audio and video",
  "call.switchCamera": "Switch to {camera}",
  "call.switchOutput": "Play sound through {device}",
  "call.moreOptions": "More options",
  "call.closePanel": "Close panel",
  "call.waitingForOthers": "Waiting for other people to join.",
  "call.pin": "Pin to the main view",
  "call.unpin": "Unpin",
  "call.host": "Host",
  "call.waitingToBeLetIn": "Waiting to be let in",
  "call.waitingBody": "A host has to let you in. This page updates by itself as soon as they do.",
  "call.ended": "The meeting has ended",
  "call.removedByHost": "A host removed you from the meeting",
  "call.notIn": "You are not in the meeting",
  "call.youLeft": "You have left the meeting.",
  "call.rejoin": "Rejoin",
  "call.backToMeetings": "Back to meetings",
  "call.backToWhereYouCameFrom": "Back to where you came from",
  "call.notFound": "That meeting could not be found",
  "call.notFoundBody": "Check the code, or ask whoever invited you for a fresh link.",
  "call.speakingWhileMuted": "You are speaking, but your microphone is off",
  "call.mutedByHost": "A host muted you",
  "call.someoneCouldNotBeHeard": "Some participants could not be heard or seen",

  "people.inMeeting": "In the meeting ({count})",
  "people.waiting": "Waiting to join ({count})",
  "people.admit": "Admit {name}",
  "people.deny": "Deny {name}",
  "people.muteEveryone": "Mute everyone",
  "people.mutedEveryoneResult": "Muted {count} people",
  "people.mutedNobody": "Everybody was already muted",
  "people.options": "Options for {name}",
  "people.mute": "Mute",
  "people.makeRole": "Make {role}",
  "people.remove": "Remove from meeting",
  "people.lobbyOn": "Lobby is on",
  "people.giveControl": "Let them present",
  "people.presenting": "Presenting",
  "people.allowedTo": "Allowed to",
  "grant.mic": "Use their microphone",
  "grant.cam": "Use their camera",
  "grant.share": "Share their screen",
  "grant.draw": "Draw on the slides",
  "grant.upload": "Put up new slides",
  "board.takeControl": "Take over presenting",
  "board.someoneElsePresenting": "{name} is presenting",
  "board.youArePresenting": "You are presenting",
  "role.host": "Host",
  "role.cohost": "Co-host",
  "role.presenter": "Presenter",
  "role.guest": "Guest",

  "chat.placeholder": "Send a message",
  "chat.send": "Send",
  "chat.message": "Message",
  "chat.empty":
    "Messages sent here are visible to everyone in the meeting and are not kept afterwards.",
  "chat.whisperFrom": "{name} whispered: {body}",
  "chat.whisperTo": "Whisper to {name}",
  "chat.privateTo": "Private to {name}",
  "chat.privateFrom": "Private",
  "chat.toEveryone": "Everyone",
  "chat.recipient": "Send to",
  "chat.whisperPlaceholder": "Private message to {name}",
  "chat.whisperNote": "Only {name} will see this.",

  "board.present": "Present",
  "board.tools": "Drawing tools",
  "board.presentBody":
    "Everyone in the meeting sees the same page, and anyone who can present may draw on it.",
  "board.uploadDocument": "Upload a PDF or PowerPoint",
  "board.uploadImages": "Upload images as slides",
  "board.blank": "Blank whiteboard",
  "board.notAllowed": "The host has not given you permission to put slides up in this meeting.",
  "board.uploading": "Uploading {percent}%",
  "board.checking": "Checking whether this file is already here",
  "board.alreadyHere": "{title} is already in this meeting, so it opens without uploading again",
  "board.noConversion":
    "Document conversion is not configured on this server, so PDF and PowerPoint uploads are unavailable. Images and blank whiteboards still work.",
  "board.limits": "Up to {size} and {pages} pages per document.",
  "board.presenting": "Presenting {title}, page {page} of {total}.",
  "board.tooLarge": "{file} is {size}, over the {limit} limit",
  "board.fileEmpty": "{file} is empty, so there is nothing to present",
  "board.fileUnsupported": "{file} is not a kind of file that can be presented",
  "board.tooManyPages": "That is {count} images, and one deck holds {limit}",
  "board.preparing": "Preparing slides",
  "board.preparingProgress": "Preparing slides ({page} of {total})",
  "board.previousPage": "Previous page",
  "board.nextPage": "Next page",
  "board.zoomIn": "Zoom in",
  "board.zoomOut": "Zoom out",
  "board.zoomPercent": "{percent}%",
  "board.fitScreen": "Fit the whole page",
  "board.fullWidth": "Fill the width",
  "board.pan": "Move the page",
  "board.stopPresenting": "Stop presenting",
  "board.undo": "Undo your last stroke",
  "board.clearPage": "Clear this page for everyone",
  "board.textPrompt": "Text to add",
  "board.textPromptBody": "It lands where you tapped, and everyone in the meeting sees it.",
  "board.textPlaceholder": "Type the text",
  "board.addText": "Add text",
  "board.colour": "Colour {colour}",
  "board.thickness": "Thickness {size}",
  "board.palette": "Colours",
  "board.moreColours": "More colours, {colour} selected",
  "board.customColour": "Custom",
  "colour.red": "Red",
  "colour.orange": "Orange",
  "colour.amber": "Amber",
  "colour.yellow": "Yellow",
  "colour.lime": "Lime",
  "colour.green": "Green",
  "colour.emerald": "Emerald",
  "colour.teal": "Teal",
  "colour.cyan": "Cyan",
  "colour.sky": "Sky blue",
  "colour.blue": "Blue",
  "colour.indigo": "Indigo",
  "colour.violet": "Violet",
  "colour.purple": "Purple",
  "colour.fuchsia": "Fuchsia",
  "colour.pink": "Pink",
  "colour.rose": "Rose",
  "colour.brown": "Brown",
  "colour.slate": "Slate",
  "colour.ink": "Ink",
  "colour.white": "White",
  "tool.pen": "Pen",
  "tool.highlighter": "Highlighter",
  "tool.line": "Line",
  "tool.arrow": "Arrow",
  "tool.rect": "Rectangle",
  "tool.ellipse": "Ellipse",
  "tool.text": "Text",
  "tool.eraser": "Eraser",

  "device.microphone": "Microphone",
  "device.camera": "Camera",
  "device.speakers": "Speakers",
  "effect.background": "Background",
  "effect.none": "Off",
  "effect.blur": "Blur",
  "effect.blurStrong": "Strong blur",
  "effect.hint":
    "Everyone in the meeting sees the effect, not just you. It runs on this device, and nothing leaves it.",
  "effect.unsupported": "This browser cannot run background effects.",
  "device.noOutputPicker":
    "This browser does not let a page choose the output device. Change it in your system settings instead.",
  "device.namesAfterPermission":
    "Device names appear once you have allowed access to the camera or microphone.",

  "mic.title": "Microphone",
  "mic.settingsBody":
    "How you sound to everybody else. Applies to every meeting you join in this browser.",
  "mic.level": "Input level",
  "mic.levelBody":
    "Say something. The bar follows what the microphone is picking up, before anything is sent.",
  "mic.levelOff": "Turn your microphone on to see what it is picking up.",
  "mic.noiseSuppression": "Noise suppression",
  "mic.noiseSuppressionBody":
    "Takes out a fan, a keyboard and the hum of a room. On unless you have a reason.",
  "mic.echoCancellation": "Echo cancellation",
  "mic.echoCancellationBody":
    "Stops what your speakers are playing being sent back into the room as an echo. Turn it off only when you are wearing headphones.",
  "mic.autoGain": "Automatic level",
  "mic.autoGainBody":
    "Lets the browser even out how loud you are as you move nearer to the microphone and away from it.",
  "mic.noBrowserProcessing":
    "This browser does not let a page change how it processes the microphone.",
  "mic.quality": "Audio quality",
  "mic.qualitySpeech": "Voice",
  "mic.qualitySpeechBody":
    "One voice at a time, and nothing at all sent through the silence between sentences. The right answer for a meeting.",
  "mic.qualityClear": "Clear voice",
  "mic.qualityClearBody":
    "Twice the bitrate, for a voice on a connection that can afford to sound better.",
  "mic.qualityMusic": "Music",
  "mic.qualityMusicBody":
    "Both channels, four times the bitrate and nothing cut off between phrases. For an instrument or a recording, not for talking.",
  "mic.volume": "Microphone volume",
  "mic.clarity": "Clarity",
  "mic.clarityBody":
    "Clarity lifts the part of a voice that carries consonants and cuts the rumble underneath it, which is what makes a quiet speaker easier to follow.",
  "mic.gate": "Noise gate",
  "mic.gateOff": "Off",
  "mic.gateBody":
    "The gate closes the microphone completely below the level marked on the bar, so a room nobody is talking in sends nothing at all. Raise it until the marker sits above your room and below your voice.",
  "mic.percent": "{value}%",
  "mic.volumeMin": "Quietest",
  "mic.volumeMax": "Loudest",
  "mic.clarityMin": "Off",
  "mic.clarityMax": "Most",
  "mic.gateMax": "Strictest",
  "mic.reset": "Reset to defaults",

  "voice.title": "Voice",
  "voice.none": "Normal",
  "voice.woman": "Woman",
  "voice.man": "Man",
  "voice.chipmunk": "Chipmunk",
  "voice.giant": "Giant",
  "voice.robot": "Robot",
  "voice.alien": "Alien",
  "voice.custom": "Custom",
  "voice.hint":
    "Everyone in the meeting hears the voice you pick, not the one you have. It is made on this device and nothing extra is sent.",
  "voice.listen": "Hear myself",
  "voice.stopListening": "Stop",
  "voice.listenBody": "Put headphones on first, or the room will hear itself.",
  "voice.unsupported": "This browser cannot change a voice.",
  "voice.pitch": "Pitch",
  "voice.pitchMin": "Deeper",
  "voice.pitchMax": "Higher",
  "voice.semitones": "{value} semitones",
  "voice.noShift": "No change",
  "voice.formant": "Voice size",
  "voice.formantMin": "Bigger",
  "voice.formantMax": "Smaller",
  "voice.customBody":
    "Pitch is the note you speak on. Voice size is how big the throat behind it sounds, and moving the two together is what makes a different voice believable rather than merely high or low.",

  "sound.title": "Sounds",
  "sound.cues": "Sound effects",
  "sound.cuesBody": "A short tone when somebody joins, leaves, raises a hand or sends a message.",
  "sound.speech": "Spoken announcements",
  "sound.speechBody": "Says what just happened out loud, in the language this page is in.",
  "sound.settingsBody": "Applies to every meeting you join in this browser.",
  "sound.volume": "Sound volume",
  "sound.test": "Test",
  "sound.percent": "{value}%",
  "sound.volumeMin": "Silent",
  "sound.volumeMax": "Loudest",
  "sound.noVoice": "This browser has no {language} voice installed, so nothing is said aloud.",
  "sound.joined": "{name} joined",
  "sound.joinedMany": "{count} people joined",
  "sound.left": "{name} left",
  "sound.leftMany": "{count} people left",
  "sound.knocking": "{name} is waiting to be let in",
  "sound.knockingMany": "{count} people are waiting to be let in",
  "sound.admitted": "You are in",
  "sound.chatMessage": "Message from {name}",
  "sound.chatMessageMany": "{count} new messages",
  "sound.handRaised": "{name} raised a hand",
  "sound.recordingOn": "Recording has started",
  "sound.recordingOff": "Recording has stopped",
  "sound.speakingWhileMuted": "Your microphone is off",
  "sound.grantedMic": "You can use your microphone",
  "sound.revokedMic": "You can no longer use your microphone",
  "sound.grantedCam": "You can use your camera",
  "sound.revokedCam": "You can no longer use your camera",
  "sound.grantedShare": "You can share your screen",
  "sound.revokedShare": "You can no longer share your screen",
  "sound.grantedDraw": "You can draw on the slides",
  "sound.revokedDraw": "You can no longer draw on the slides",
  "sound.grantedUpload": "You can put up slides",
  "sound.revokedUpload": "You can no longer put up slides",
  "sound.permissionsChanged": "What you are allowed to do has changed",
  "sound.nowHost": "You are the host now",
  "sound.nowCohost": "You are a co-host now",
  "sound.nowPresenter": "You can present now",
  "sound.nowGuest": "You are a guest now",
  "sound.mutedByHost": "A host muted you",
  "sound.screenOn": "{name} is sharing a screen",
  "sound.screenOff": "{name} stopped sharing",
  "sound.presenting": "Now presenting {title}",
  "sound.reconnecting": "Connection lost. Reconnecting",
  "sound.reconnected": "You are back in the meeting",
  "sound.ended": "The meeting has ended",

  "recordings.show": "Recordings",
  "recordings.showCount": "Recordings ({count})",
  "recordings.startedBy": "started by {name}",
  "recordings.none": "This room has no recordings yet.",
  "recordings.inProgress": "Recording now",
  "recordings.copyLink": "Copy link",
  "recordings.linkCopied": "Link copied. Anybody with it can watch the recording.",
  "recordings.watch": "Watch",
  "playback.loading": "Opening the recording",
  "playback.missing": "That recording is not here",
  "playback.missingBody":
    "The link may be wrong, or the recording may have been deleted. Recordings are only reachable through the exact link they were shared with.",
  "playback.unavailable": "The recording could not be loaded",
  "playback.unavailableBody": "Something went wrong reaching the server. Try again in a moment.",
  "playback.recordedBy": "Recorded by {name}",
  "playback.noBoard": "Nothing was being presented at this point",
  "playback.chat": "Chat",
  "playback.noChat": "Nothing has been said yet at this point.",
  "playback.play": "Play",
  "playback.pause": "Pause",
  "playback.seek": "Position in the recording",
  "playback.micOn": "Microphone on",
  "playback.micOff": "Microphone off",
  "playback.camOn": "Camera on",
  "playback.camOff": "Camera off",

  "settings.lobby": "Lobby",
  "settings.lobbyBody": "People wait until a host lets them in.",
  "settings.allowGuests": "Allow guests",
  "settings.allowGuestsBody": "Anyone with the link can join by entering a name.",
  "settings.muteOnEntry": "Mute on entry",
  "settings.muteOnEntryBody": "Everyone arrives muted.",
  "settings.shareLink": "Show the joining link",
  "settings.shareLinkBody": "The room code and the copy button, in the meeting header.",
  "settings.allowScreenShare": "Allow screen sharing",
  "settings.allowBoard": "Allow presenting",
  "settings.allowBoardBody": "Slides and the whiteboard.",
  "settings.allowChat": "Allow chat",
  "settings.allowWhisper": "Allow private messages",
  "settings.allowWhisperBody":
    "People can write to one person in the meeting instead of to everyone. Turn this off for a room where everything said should be said in front of everybody.",
  "settings.allowRecording": "Allow recording",
  "settings.allowRecordingBody":
    "A host can record the meeting. Everybody in the room is told while it is being recorded.",
  "settings.autoRecord": "Record every meeting",
  "settings.autoRecordBody":
    "Recording starts on its own when the meeting does, so nobody has to remember. A moderator can still stop it.",
  "settings.tabDevices": "Audio & video",
  "settings.tabMeeting": "Meeting",
  "settings.tabGuests": "Guests",
  "settings.pageSubtitle":
    "Your profile, your password, and how meetings sound before you join one.",
  "settings.memberSince": "With us since {date}",
  "settings.groupAccount": "Account",
  "settings.groupAudio": "Audio",
  "settings.sections": "Settings sections",
  "settings.groupEntry": "Getting in",
  "settings.groupDuring": "During the meeting",
  "settings.groupRecording": "Recording",
  "settings.guestDefaults": "What guests may do",
  "settings.guestDefaultsBody":
    "Applies to people who join as guests. Anybody you promote, or allow individually, keeps what you gave them.",
  "settings.hostOnly": "Only a host can change these.",
  "settings.endForEveryone": "End the meeting for everyone",

  "settings.stage": "Layout",
  "settings.stageBody": "How this meeting is arranged, for everybody in it.",
  "settings.autoJoin": "Walk straight in",
  "settings.autoJoinBody":
    "No camera and microphone screen first. For meetings people are sent to from somewhere else, where they have already chosen to join.",
  "settings.cameraOffOnEntry": "Camera off on entry",
  "settings.cameraOffOnEntryBody": "Everyone arrives with their camera off.",

  "stage.standard": "Meeting",
  "stage.standardBody": "Everybody in one grid, with the full toolbar and the panels beside it.",
  "stage.telegram": "Talk",
  "stage.telegramBody":
    "Cameras in a strip at the top, everybody else in a list under it, and one big microphone.",

  "talk.participants": "{count} participants",
  "talk.participants#one": "{count} participant",
  "talk.listening": "listening",
  "talk.speaking": "speaking",
  "talk.muted": "muted",
  "talk.wantsToSpeak": "wants to speak",
  "talk.sharing": "sharing their screen",
  "talk.youAreLive": "You are live",
  "talk.unmute": "Unmute",
  "talk.video": "Video",
  "talk.leave": "Leave",
  "talk.putAway": "Put the call away",
  "talk.askToSpeak": "Ask to speak",
  "talk.cancelAsk": "Never mind",
  "talk.letThemSpeak": "Let {name} speak",
  "talk.muteThem": "Mute {name}",
  "talk.noCameras": "Nobody has their camera on.",

  "lobby.knocking": "{name} has been asked to let you in.",
  "lobby.stillWaiting": "Still waiting. They may not have seen it yet.",
  "lobby.notYetLive": "Nobody can hear or see you yet",

  "error.unauthorized": "Please sign in again.",
  "error.forbidden": "You are not allowed to do that.",
  "error.not_found": "That could not be found.",
  "error.bad_credentials": "That email and password do not match.",
  "error.email_taken": "That address already has an account.",
  "error.registration_closed": "This server is not accepting new accounts.",
  "error.session_revoked":
    "You were signed out because this sign-in was used twice. Please sign in again.",
  "error.session_expired": "Your session has expired. Please sign in again.",

  "error.crashTitle": "Something went wrong",
  "error.crashBody":
    "This page stopped responding. Reloading usually fixes it, and a meeting you were in can be rejoined from its link.",
  "error.crashReload": "Reload",
  "error.room_full": "This meeting is full.",
  "error.guests_not_allowed": "This meeting is only open to signed-in people.",
  "error.host_absent": "The meeting has not started yet.",
  "error.meeting_cancelled": "This meeting has been cancelled.",
  "error.bad_passcode": "That passcode is not right.",
  "error.bad_code": "That is not a valid meeting code.",
  "error.already_sharing": "Somebody else is already sharing their screen.",
  "error.no_media_server":
    "This server has no media server configured, so audio and video are unavailable.",
  "error.media_error": "The media server could not be reached.",
  "error.recording_disabled": "This server does not record meetings.",
  "error.already_joined": "You are already in this meeting.",
  "error.no_board": "Nothing is being presented.",
  "error.not_presenting": "Somebody else is presenting.",
  "error.record_failed": "The recording could not be started.",
  "error.too_long": "That is too large to send.",
  "error.conversion_unavailable": "This server cannot convert documents. Upload images instead.",
  "error.too_large": "That file is larger than this server allows.",
  "error.unsupported_type": "That file type cannot be presented.",
  "error.too_many_rooms": "You have reached the limit on rooms. Delete one first.",
  "error.network_error": "The server could not be reached.",
  "error.unavailable": "The server is temporarily unavailable.",
  "error.timeout": "The server did not answer in time.",
  "error.disconnected": "The connection to the meeting was lost.",
  "error.media_denied":
    "Your browser refused access to the camera or microphone. Allow it in the address bar and try again.",
  "error.media_missing": "No camera or microphone of that kind was found.",
  "error.media_busy": "Another application is using that device.",
  "error.media_unsupported": "This browser cannot do that.",
  "error.media_unknown": "That device could not be opened.",

  "notFound.title": "Not found",
  "notFound.body": "The page you were looking for does not exist.",
  "notFound.home": "Go to the home page",

  "schedule.timezone": "Time zone",
  "schedule.endsBeforeStart": "The end has to come after the start.",
  "calendar.previousMonth": "Previous month",
  "calendar.nextMonth": "Next month",
  "calendar.today": "Today",
  "emails.remove": "Remove {email}",
  "emails.notAddresses": "Not an email address: {list}",
  "meeting.inZone": "{time} in {zone}",
} as const;

export type MessageKey = Exclude<keyof typeof en, `${string}#${string}`>;

export type Catalog = Record<MessageKey, string> & {
  [key in `${MessageKey}#${string}`]?: string;
};
